<template>
  <div>
    <div class="pp-post-layer-title">
      Welcome to <br />
      Upsell & Cross Sell 🎉
    </div>

    <div class="pp-post-layer-body">
      <p>Hello {{ userName || "" }} 😀 ,</p>
      <p>We’re so glad you’re here, let us know if you have any questions.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GreetPost",
  props: {
    userName: String
  }
}
</script>

<style scoped>
</style>